<template>
    <div>
        <top_box></top_box>
        <div class="main">
            <div class="inpunt_box">
                <el-input :placeholder="$t('m.MallCenter_06')" v-model="value">
                    <i slot="prefix" style="display: flex;align-items: center;">
                        <img class="header-icon" style="width:16px;height:16px" src="../static/images/sousuoicon.png"
                            alt="" />
                    </i>

                    <template slot="append">
                        <span class="search_btn" @click="confirm">{{$t('m.home_01')}}</span>
                    </template>
                </el-input>

            </div>
            <div class="return_box pointer" @click="return_">
                <img src="../static/return_icon.png" alt="">
                <span>{{$t('m.PlaceOrder_01')}}</span>
            </div>
            <div class="textbox">
                <div class="title">
                    {{info_data.title}}
                </div>
                <div class="time">
                    {{$t('m.home_17')}}：{{info_data.publish_time}}
                </div>
                <div class="text" v-html="info_data.content">
                    
                </div>
            </div>
        </div>
		
		<!-- 公共底部 -->
		<fot_box></fot_box>
    </div>
</template>

<script>
import top_box from '../components/header_top'
import fot_box from '../components/foot'
import encryption from '@/utils/encryption.js'
export default {
    components: {
        top_box,fot_box

    },
    data() {
        return {
            user_data: {},
            info_data:{},
            value: '',
        }
    },
    mounted() {
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data
        this.getData(this.$route.query.id)
    },
    methods: {
        getData(id){
            let param ={
                id:id
            }
            let sing = encryption.getSing(param)
        
            this.$api.news_details(param,sing).then((res)=>{
                if(res.data.code == 1){
                    this.info_data = res.data.data
                    this.info_data.publish_time = this.$common.timetrans(this.info_data.publish_time,0,'/','/','') 
                }
            })
        },
        confirm() {

        },
        return_() {
            this.$router.go(-1)
        }
    }

}
</script>

<style lang="scss" scoped>
.main {
    padding: 35px 17.5% 70px 17.5%;
    margin-top: 13px;
    background-color: #fff;
    width: 100%;

    ::v-deep .el-input__prefix {
        display: flex;
        margin-left: 20px;
    }

    ::v-deep .el-input__inner {

            padding-left: 70px !important;
            font-size: 16px;
        }

    .inpunt_box {
        width: 100%;

        border: 2px solid #ef5843;
        background-color: #ef5843;
        border-radius: 3px;

        .header-icon {
            margin-right: 4px;
            width: 24px !important;
            height: 24px !important;
        }

        ::v-deep .el-input__inner {
            border: 0 !important;
            border-radius: 0;
            height: 72px;
            background-color: #f6f7fa;
        }

        ::v-deep .el-input-group__append {
            color: #fff;
            background-color: #ef5843;
            cursor: pointer;
            border: 0 !important;
            width: 100px;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
        }

        .search_btn {
            color: #fff;
            font-size: 15px;
        }
    }

    .return_box {
        margin-top: 30px;
        display: flex;
        align-items: center;
        font-size: 14px;

        span {
            margin-left: 10px;
            color: #697185;
        }
    }

    .textbox {
        margin-top: 40px;

        .title {
            font-weight: bold;
            text-align: center;
            font-size: 35px;
        }

        .time {
            font-size: 15px;
            text-align: center;
            color: #1d1e28;
            margin-top: 10px;
        }

        .text {
            margin-top: 50px;
            color: #2e3341;
            div{
                line-height: 140%;
                letter-spacing:0.5px;
                margin-top: 25px;
            }
        }
    }
}



// 宽度小于1200px
@media screen and (max-width: 1200px){
	.main{
		padding: 1rem;
		.inpunt_box{display: none;}
		.return_box{
			margin-top: 0;
		}
		.textbox{
			margin-top: 1rem;
			.title{
				font-size: 1.575rem;
			}
		}
	}
}
</style>